import React, { Component, PropTypes } from "react";

import styled from "styled-components";

import { media } from "style-utils";

import {
  NitroIcon,
  NitroText,
  NitroGrid,
  NitroGrids,
  NitroHeading,
  NitroParagraph,
  NitroPanel,
  NitroContentNotAvailable
} from "nitro-components";

const OVER_UTILISED ="Over Utilised";
const UNDER_UTILISED = "Under Utilised";
const KEY_UNDERS = "key unders";
const KEY_OVERS = "key overs";

const MetricContainer = styled.div`
  width:95%;
`;

const Metrics = styled.div`
  width :90%;
  position: relative;
  background: ${props => props.theme.color.white};
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
`;
const MetricContent = styled.div`
   padding: 30px 20px;
   margin: auto;
`;

const UtlisationKeyMetricContent = styled.div`
  padding-top:5.5%;
  padding-bottom:5.5%;
  width:100%;
  margin-left:auto;
  margin-right:auto;
  text-align:center;
  border-radius: 0px 0px 2px 2px;
  vertical-align: middle;
  color:${props => props.theme.color.white};
  background-color: ${props => (props.type === KEY_UNDERS ? props.theme.color.under : props.theme.color.negative)};
`;

const UtilisationNumber = styled.div`
  font-size: 48px;
  color: ${props => props.theme.color.base1};
  text-align: center;
  font-weight: normal;
`;

const UtilisationMetric = ({
  utilisation,
  description,
  keyUtilisation,
  keyUtilisationType
}) => {
  return (
   
      <Metrics>
      <MetricContent>
        <UtilisationNumber>{utilisation}</UtilisationNumber>
        <NitroHeading label={description} align="center" size="2" />
      </MetricContent>
      <UtlisationKeyMetricContent type={keyUtilisationType}>
        <NitroIcon
          right={4}
          name={
            keyUtilisationType === KEY_UNDERS
              ? "solid-yellow-warning"
              : "solid-red-warning"
          }
          size={30}
        />
        <NitroText bold size={14}>{keyUtilisation}{" "}</NitroText>
        <NitroText size={14}>{keyUtilisationType}</NitroText>

      </UtlisationKeyMetricContent>
    </Metrics>
  );
};

const ChartUtilisation = ({
  dataType,
  exportOptions,
  plotOptions,
  data,
  error
}) => {
  const utilisationObj = data.data[0];
  const overUtilisation = {
    keys: utilisationObj && utilisationObj.KeyOvers,
    total: utilisationObj && utilisationObj.Overs,
    title: OVER_UTILISED,
    keyUtilisationType: KEY_OVERS
  };
  const underUtilisation = {
    keys: utilisationObj && utilisationObj.KeyUnders,
    total: utilisationObj && utilisationObj.Unders,
    title: UNDER_UTILISED,
    keyUtilisationType: KEY_UNDERS
  };

  const utilisations = [underUtilisation, overUtilisation];

  return (
    <MetricContainer>
      <NitroGrids>
        {utilisations && utilisations.map((dataObj, index) => {
          return (
            <NitroGrid grid={2} key={index}>
       
              <UtilisationMetric
                utilisation={dataObj.total || 0}
                description={dataObj.title}
                keyUtilisation={dataObj.keys || 0}
                keyUtilisationType={dataObj.keyUtilisationType}
              />
            
              

            </NitroGrid>
          );
        })}

      </NitroGrids>
    </MetricContainer>
  );
};

ChartUtilisation.propTypes = {
  dataType: PropTypes.string,
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool // TODO .isRequired
};

export default ChartUtilisation;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartUtilisation.js